import { useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// A view-state value kept in the URL query, so every change is a browser history entry and
// Back / Forward restore it exactly. The fallback value is left out of the URL.
export function useUrlState(name, fallback) {
  const location = useLocation();
  const navigate = useNavigate();
  const locRef = useRef(location);
  locRef.current = location;
  const value = new URLSearchParams(location.search).get(name) ?? fallback;
  const set = useCallback((next, opts) => {
    const loc = locRef.current;
    const params = new URLSearchParams(loc.search);
    const cur = params.get(name) ?? fallback;
    const v = typeof next === "function" ? next(cur) : next;
    if (v === cur) return;
    if (v === fallback || v === null || v === undefined || v === "") params.delete(name);
    else params.set(name, String(v));
    const search = params.toString();
    navigate({ pathname: loc.pathname, search: search ? `?${search}` : "" }, opts);
    locRef.current = { ...loc, search: search ? `?${search}` : "" };
  }, [name, fallback, navigate]);
  return [value, set];
}
